export default __webpack_public_path__ + "static/media/enterprise-assets.9ff58db4.png";